import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { InviteByEmailData } from '../../types';
import { EmailInviteApi } from '../../apis/email-invite-api';
import type { EmailInviteRepository } from '../../services/share-tools-repository';

@injectable()
export class EmailInviteRepositoryImpl implements EmailInviteRepository {
  // eslint-disable-next-line no-useless-constructor
  constructor(@inject(EmailInviteApi) private emailInviteApi: EmailInviteApi) {}

  inviteByEmail(data: InviteByEmailData) {
    return this.emailInviteApi.inviteByEmail(data);
  }
}
